<template>
  <div class="flex justify-center">
    <div class="text-text-neutral-medium px-8 py-10 max-w-[1440px] w-full">

      <!-- Page Title -->
      <h1 class="text-lg md:text-3xl font-semibold flex gap-2  relative flex items-center justify-center md:justify-start">
        <span class="absolute left-0 flex md:hidden items-center" @click.prevent="emitter.emit('open-account-popup');">
          <!-- TODO: replace with lib icon -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0893 4.41074C13.4147 4.73618 13.4147 5.26382 13.0893 5.58926L8.67851 10L13.0893 14.4107C13.4147 14.7362 13.4147 15.2638 13.0893 15.5893C12.7638 15.9147 12.2362 15.9147 11.9107 15.5893L6.91074 10.5893C6.58531 10.2638 6.58531 9.73618 6.91074 9.41074L11.9107 4.41074C12.2362 4.08531 12.7638 4.08531 13.0893 4.41074Z" fill="#6CBFFF"/>
          </svg>
        </span>
        <span>Manage organization</span>
      </h1>
      <p class="mt-2 text-gray-400 text-xs md:text-sm max-w-2xl">
        Manage your team members access to premium features and view usage data.
        You can add or revoke access anytime.
      </p>

      <!-- Section Navigation -->
      <nav class="mt-6 flex items-center gap-1 border-b border-stroke-separator">
        <router-link
            to="/organization"
            custom
            v-slot="{ href, navigate, isExactActive }"
        >
          <a
              :href="href"
              @click="navigate"
              class="px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors"
              :class="isExactActive
                ? 'border-elements-blue text-text-neutral-extreme'
                : 'border-transparent text-text-neutral-medium hover:text-text-neutral-extreme'"
          >
            Members
          </a>
        </router-link>

        <router-link
            v-if="customVocabEnabled"
            to="/organization/vocabulary"
            custom
            v-slot="{ href, navigate, isActive }"
        >
          <a
              :href="href"
              @click="navigate"
              class="px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors"
              :class="isActive
                ? 'border-elements-blue text-text-neutral-extreme'
                : 'border-transparent text-text-neutral-medium hover:text-text-neutral-extreme'"
          >
            Custom Vocabulary
          </a>
        </router-link>
      </nav>

      <router-view></router-view>
    </div>
  </div>

  <main-footer></main-footer>
</template>

<script setup lang="ts">
import MainFooter from "@/components/MainFooter.vue";
import emitter from "@/services/emitter.service";
import { Constants } from "@/cfg/constants";

const customVocabEnabled = Constants.CUSTOM_VOCAB_ENABLED;
</script>
